import { resolveIcon as o } from "../../../helpers/index.js";
const n = (t) => {
  const r = {
    variant: "default",
    header: {
      title: t.properties?.header
    },
    tableData: {
      titles: t.properties?.columns,
      data: t.properties?.rows?.items.map((e) => ({
        icon: o(e.content.properties?.ikon),
        title: e.content.properties?.header,
        accordionData: e.content.properties?.text?.markup,
        values: e.content.properties?.values?.items.map(
          (p) => p.content.properties?.included
        )
      }))
    }
  };
  return t.contentType === "shared_optionalCoverageTable" && (r.variant = "optional", r.header = {
    ...r.header,
    icon: o(t.properties?.ikon)
  }, r.subHeader = t.properties?.subject, r.tableData = {
    data: t.properties?.rows?.items.map((e) => ({
      icon: o(e.content.properties?.ikon),
      title: e.content.properties?.header,
      accordionData: e.content.properties?.text?.markup
    }))
  }), r;
};
export {
  n as schemaDeliveryApiParser
};
